import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isNullOrUndefined } from '@uzurv/core';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Automobile, AutomobileMake, AutomobileModel } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class AutomobileService extends UzurvRestService {
  readonly resourceUrl = 'automobiles/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Returns a list of AutomobileMakes based on year.
   *
   * @param year
   */
  listMakesByYear(year: string): Observable<Array<AutomobileMake>> {
    return this.get<Array<AutomobileMake>>(`${this.resourceUrl}makes/`, { year: year }).pipe(
      map(response => Deserialize(response, AutomobileMake).sort((a, b) => a.name.localeCompare(b.name)))
    );
  }

  /**
   * Returns a list of AutomobileModels based on year and make.
   *
   * @param year
   * @param make
   */
  listModelsByYearAndMake(year: string, make: string): Observable<Array<AutomobileModel>> {
    return this.get<Array<AutomobileModel>>(`${this.resourceUrl}models/`, { year: year, make: make }).pipe(
      map(response => Deserialize(response, AutomobileModel).sort((a, b) => a.name.localeCompare(b.name)))
    );
  }

  /**
   * Gets an automobile string from an Automobile
   *
   * @param automobile
   */
  getAutomobileString(automobile: Automobile): string {
    if (
      !isNullOrUndefined(automobile) &&
      !isNullOrUndefined(automobile.year) &&
      !isNullOrUndefined(automobile.automobileModel) &&
      !isNullOrUndefined(automobile.automobileModel.automobileMake)
    ) {
      return automobile.year + ' ' + automobile.automobileModel.automobileMake.name + ' ' + automobile.automobileModel.name;
    } else {
      return null;
    }
  }

  protected getApiUrl(): string {
    return this.uzurvRestConfiguration.dotsApiUrl;
  }
}
